"use client";

import type { TextColor } from "@homeinstead/schemas";

import { cn } from "@homeinstead/ui";
import { inquiryTextColorClass } from "./inquiry-text-color";

type InquiryRedirectStatusProps = {
  textColor?: TextColor;
};

function InquiryRedirectStatus({ textColor }: InquiryRedirectStatusProps) {
  return (
    <p
      className={cn("font-jakarta text-base", inquiryTextColorClass(textColor))}
      role="status"
    >
      Redirecting&hellip;
    </p>
  );
}

export { InquiryRedirectStatus };
